import { render } from "./AHS_Refugee_Logo.vue?vue&type=template&id=1a4ee7ec"
import script from "./AHS_Refugee_Logo.vue?vue&type=script&lang=js"
export * from "./AHS_Refugee_Logo.vue?vue&type=script&lang=js"

import "./AHS_Refugee_Logo.vue?vue&type=style&index=0&id=1a4ee7ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__